<div class="flex-center">
	<img [ngSrc]="source" [alt]="alt" [priority]="priority" [height]="height" [width]="width" />
</div>
